<script lang="ts">
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'CompanyProfile',

  props: {
    solutionTitle: {
      type: String,
      default: () => ({}),
    },

    summary: {
      type: Object as PropType<Company>,
      required: true,
    },
  },
})
</script>

<template>
  <section class="section">
    <div class="o-heading__section">
      <h2 class="o-heading__section--item">
        {{ solutionTitle }}
      </h2>
    <!-- /.o-heading__section --></div>

    <div class="o-list__record is-table u-text__small">
      <dl
        v-if="summary.name"
        class="o-list__record--unit">
        <dt class="o-list__record--term u-text__bold">
          社名
        </dt>
        <dd class="o-list__record--description">
          {{ summary.name }}
        </dd>
      </dl>

      <dl
        v-if="summary.postalCode || summary.address1 || summary.address2"
        class="o-list__record--unit">
        <dt class="o-list__record--term u-text__bold">
          本社所在地
        </dt>
        <dd class="o-list__record--description">
          <ul class="ul">
            <li
              v-if="summary.postalCode"
              class="li">
              〒{{ summary.postalCode }}
            </li>
            <li
              v-if="summary.address1"
              class="li">
              {{ summary.address1 }}
            </li>
            <li
              v-if="summary.address2"
              class="li">
              {{ summary.address2 }}
            </li>
          </ul>
        </dd>
      </dl>

      <dl
        v-if="summary.capital"
        class="o-list__record--unit">
        <dt class="o-list__record--term u-text__bold">
          資本金
        </dt>
        <dd class="o-list__record--description">
          {{ summary.capital }}
        </dd>
      </dl>

      <dl
        v-if="summary.numberOfEmployees"
        class="o-list__record--unit">
        <dt class="o-list__record--term u-text__bold">
          従業員数
        </dt>
        <dd class="o-list__record--description">
          {{ summary.numberOfEmployees }}
        </dd>
      </dl>
    <!-- /.o-list__record --></div>
  </section>
</template>

<style lang="sass" scoped>
.o-heading__section
  & &--item
    line-height: 1.4
    font-weight: bold
    padding-bottom: 0.5em
    border-bottom: 1px solid $border-x-light-gray
</style>
